import React from 'react';
import PropTypes from 'prop-types';
import { Block, FilmCredits, FilmMaterials } from '../partials';

import Image from '../blocks/Image';
import Logo from '../blocks/Logo';

const propTypes = {
    handle: PropTypes.string.isRequired,
    title: PropTypes.string,
    blocks: PropTypes.array,
    poster: PropTypes.shape({
        picture: PropTypes.object,
    }),
};

const defaultProps = {
    slug: 'home',
    title: 'Film Info',
    blocks: [
        {
            id: 1,
            type: 'text',
            title: 'Hello block title',
            text: 'Lorem ... . .Intro to topic and a quick description of what to find inside. Lorem ipsum dolor sit ametta, consectetur adipiscing elit. Viva mus nec tellusin purus pulvinar interdum ac sit amet elitus. Pellentesque auctor massa non porttitor rhoncus. Nulla in lorem elit. Vestibulum mi justo, pulvinar ut luctus eget, molestie vitae eros un. Interdum et malesuada fames ac ante ipsum primis in faucibus.',
        },
        {
            id: 2,
            type: 'logo',
        },
    ],
    poster: {
        picture: {
            url: '/docs/IASYC-poster_8-5x11_1024.jpg',
        },
        dataAttributes: {
            'data-pdf': '/docs/IASYC-poster_8-5x11.pdf',
        },
        rounded: false,
        border: false,
    },
};

const InfoLayout = ({ title, blocks, handle, poster }) => (
    <div className="layout layout-with-cols layout-info">
        <div className="cols">
            <div className="col">
                <h1 className="title page-title">{title}</h1>
                <Block blocks={blocks || []} />
            </div>
            <div className="col col-very-small">
                <div className="col-inner">
                    <div className="blocks-container">
                        { handle !== 'about-the-film' ? (
                            <div className="poster">
                                <Image {...poster} />
                            </div>
                        ) : (
                            <Logo />
                        ) }
                        { handle !== 'about-the-film' ? (
                            <FilmMaterials />
                        ) : (
                            <FilmCredits />
                        )}
                    </div>
                </div>
            </div>
        </div>
    </div>
);

InfoLayout.propTypes = propTypes;
InfoLayout.defaultProps = defaultProps;

export default InfoLayout;



// WEBPACK FOOTER //
// ./components/layouts/InfoLayout.jsx